(() => {
  if (window.rbClarityConsentInstalled) return;
  window.rbClarityConsentInstalled = true;
  let started = false;
  let reloading = false;
  const project = 'yxs53vojai';
  function permitted() {
    const ageContent = document.getElementById('rb-age-content');
    if (!ageContent || ageContent.hidden) return false;
    try {
      const privacy = window.Shopify?.customerPrivacy;
      const consent = privacy?.currentVisitorConsent();
      return consent?.analytics === 'yes' && consent?.marketing === 'yes' && privacy.analyticsProcessingAllowed() && privacy.marketingAllowed();
    } catch { return false; }
  }
  function sync() {
    if (!permitted()) {
      if (started && !reloading) {
        reloading = true;
        window.clarity('consentv2', {ad_Storage: 'denied', analytics_Storage: 'denied'});
        window.setTimeout(() => window.location.reload(), 150);
      }
      return;
    }
    if (started) return;
    started = true;
    window.clarity = window.clarity || function () {
      (window.clarity.q = window.clarity.q || []).push(arguments);
    };
    window.clarity('consentv2', {ad_Storage: 'granted', analytics_Storage: 'granted'});
    const script = document.createElement('script');
    script.async = true;
    script.src = 'https://www.clarity.ms/tag/' + project;
    script.addEventListener('load', () => {
      if (permitted()) document.dispatchEvent(new CustomEvent('rb:clarity-ready'));
      else sync();
    });
    document.head.appendChild(script);
  }
  document.addEventListener('visitorConsentCollected', sync);
  document.addEventListener('rb:age-accepted', sync);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync, {once: true});
  else sync();
  if (!window.Shopify?.customerPrivacy && typeof window.Shopify?.loadFeatures === 'function') {
    window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.1'}], error => { if (!error) sync(); });
  }
})();
